import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";

const texts = ["BOOK NOW", "LIMITED TIME", "DON'T MISS OUT"];

export const RotatingBookNow = ({ settings }) => {
  const [i, setI] = useState(0);
  const list = settings?.book_now_texts?.length ? settings.book_now_texts : texts;
  const to = settings?.book_now_event_id ? `/events/${settings.book_now_event_id}?book=1` : "/events";

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % list.length), 2200);
    return () => clearInterval(t);
  }, [list.length]);

  return (
    <Link to={to} className="book-now-float" data-testid="rotating-book-now">
      <span className="book-now-dot" />
      <span key={i} className="book-now-text">{list[i]}</span>
    </Link>
  );
};
